// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__JpI6r","badge__label":"badge_badge__label__1B2tU"};